import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FlexBox } from '../box';
import { styled } from '../styled';
import { getPaletteColor } from '../theme';
import { Typography } from '../typography';
const StyledFlexBox = styled(FlexBox)(({ theme, $lineColor }) => ({
    borderLeft: '4px solid',
    borderColor: getPaletteColor(theme, $lineColor)
}));
export const ContextLine = React.forwardRef(({ color, lineColor, label, children }, ref) => {
    return (_jsxs(StyledFlexBox, { ref: ref, stack: true, gap: 0.5, padding: [0.25, 0, 0.25, 2], "$lineColor": lineColor, children: [_jsx(Typography, { color: color, children: label }), children] }));
});
